import React, { Component } from "react"
import config from "react-global-configuration"

import { Forms } from "../../../styleguide/js/components/forms"

class AmendForgotReferenceModal extends Component {
  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
  }
  componentDidMount() {
    new Forms({ el: this.containerRef.current })
  }

  render() {
    const textKeys = config.get("textKeys.amendment.forgotModal") || {}
    const validationMessage = textKeys.validationMessage || "Email er ikke i korrekt format."

    return (
      <div className="overlay overlay--modal overlay--fixed is-active">
        <div className="modal modal--fat" ref={this.containerRef}>
          <button className="button button--icon js--close-modal" onClick={() => this.props.amendForgotReferenceModalToogle()}>
            <span className="icon">
              <svg className="svg-icon svg-icon--close-new">
                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                  &nbsp;
                </use>
              </svg>
            </span>
          </button>
          <div className="modal__content">
            <div className="modal__content__inner">
              <div className="modal__top">
                <header className="a--left">
                  <h3 className="headline-md">{textKeys.title || "Glemt bookingnummer?"}</h3>
                  <span
                    dangerouslySetInnerHTML={{
                      __html:
                        textKeys.description ||
                        "Ud fra din mailadresse kan vi gensende din booking-kvittering.<br/>Hvis du har flere fremtidige bookinger vil du modtage kvitteringerne for dem alle sammen.",
                    }}
                  ></span>
                </header>
              </div>
              <div className="modal__middle">
                <div className="grid form">
                  <div className="grid-item col--12 col-sm--9">
                    <div className="form__field form__field--text is-bound">
                      <span className="form__valid" />
                      <input
                        className="form__item "
                        tabIndex="1"
                        type="email"
                        name="email"
                        onBlur={this.props.updateAmmendmentEmailValue}
                        defaultValue={this.props.ammendmentEmail}
                      />
                      <label htmlFor="email" className="form__label">
                        <span className="form__label__text">
                          {textKeys.label || "Din e-mail"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="grid-item col--12 col-sm--3">
                    <button
                      className="button button--medium button--general d-flex js--close-modal rm-this-class rm-this-class-hide-default"
                      onClick={() =>
                        this.props.ammendmentEmail.includes("@")
                          ? this.props.resendNextAvailableBookingConfirmation(this.props.ammendmentEmail)
                          : (document.querySelector(".validation-message").style.display = "block")
                      }
                    >
                      <span className="icon">
                        <svg className="svg-icon svg-icon--planeduo">
                          <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-planeduo">
                            &nbsp;
                          </use>
                        </svg>
                      </span>
                      <span className="text">{textKeys.button || "Send"}</span>
                    </button>
                  </div>
                  <p className={"validation-message"}> {validationMessage} </p>
                </div>
              </div>
              <div className="modal__bottom"></div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default AmendForgotReferenceModal
